module.exports = __webpack_public_path__ + "static/media/logo-blue-no-text.ab604f5d.svg";